import React, { lazy, Suspense, useEffect, useState } from 'react'
import BlaBlaHead from '../blabla/BlaBlaHead';
import CareemMulty from './CareemMulty';

const CareemBoost = lazy(() => import('./CareemBoost'));
const CareemFlow = lazy(() => import('./CareemFlow'));
const CareemAttract = lazy(() => import('./CareemAttract'));
const GroceryMarket = lazy(() => import('../groceryApp/GroceryMarket'));
const UberEatsPower = lazy(() => import('../uberEats/UberEatsPower'));
const UberEatsAdvance = lazy(() => import('../uberEats/UberEatsAdvance'));
const ShuttleAppreciation = lazy(() => import('../../shuttle_software/ShuttleAppreciation'));
const TaxiFaq = lazy(() => import('../../taxiDispatchSoftware/TaxiFaq'));
const CareemApart = lazy(() => import('./CareemApart'));
const CareemDemand = lazy(() => import('./CareemDemand'));
const CareemFeature = lazy(() => import('./CareemFeature'));
const CareemProcess = lazy(() => import('./CareemProcess'));

const HeadData = {
  label: "careem clone",
  title: "The Ultimate Multi-Delivery Solution",
  description: "The Careem Clone app by Mobility Infotech brings food, grocery, courier, pharmacy, and parcel deliveries together in a single platform. It is designed to maximize efficiency and customer satisfaction while helping businesses scale in the competitive on-demand economy.",
  image: "/assets/home/careem-banner-img.webp",
  backImage: "/assets/home/careem-banner-back-img.webp",
  btn: "Get Started Now",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Careem Clone App",
        slug: ""
      },
    ]
  }
};

const boostData = {
  headingPart1: "How AI-Powered",
  headingPart2: "Careem Clone ",
  headingPart3: "Boosts Efficiency",
  subHeading: "The AI-powered Careem Clone by Mobility Infotech enhances performance with automation, smart routing, faster deliveries, and cost reduction.",
  boxes: [
    {
      image1: "/assets/home/uber-eats-process-1.webp",
      image2: "/assets/home/uber-eats-process-hover-1.webp",
      head: "AI-Powered Virtual Assistant",
      desc: "Integrated AI recommends services tailored to customer preferences and search history. It also ensures instant support through AI-powered live chat and automated assistance.",
    },
    {
      image1: "/assets/home/uber-eats-process-2.webp",
      image2: "/assets/home/uber-eats-process-hover-2.webp",
      head: "AI-Powered Personalized Engine",
      desc: "The app delivers personalized search results based on user behavior. It keeps customers engaged with push notifications, and emails—driving loyalty and repeat orders.",
    },
    {
      image1: "/assets/home/uber-eats-process-3.webp",
      image2: "/assets/home/uber-eats-process-hover-3.webp",
      head: "AI-Driven Dynamic Pricing",
      desc: "Our smart AI pricing model analyzes competitor rates, demand spikes, and peak hours ( weekends) before setting prices—helping you stay competitive while maximizing profits.",
    },
    {
      image1: "/assets/home/uber-eats-process-4.webp",
      image2: "/assets/home/uber-eats-process-hover-4.webp",
      head: "AI-powered Automated Search",
      desc: "With AI-powered search, results are displayed based on previous user patterns and individual preferences. This ensures accurate, relevant, and faster results—enhancing overall satisfaction.",
    },
  ]
}

const attractData = {
  titlePart1: "What Attracted ",
  titlePart2: "You to Us",
  desc: "Building the Best Multi-Service Platform Using the Right Methods",
  boxes: [
    {
      image: "/assets/home/careem-attract-1.webp",
      heading: "Customizable",
      description: "Every market is unique. Our Careem Clone app can be tailored to your business model, service categories, and operational scale—giving you the flexibility to grow.",
    },
    {
      image: "/assets/home/careem-attract-2.webp",
      heading: "Latest Tech Trends",
      description: "Stay ahead with a platform that adapts to emerging technologies. From AI to smart integrations, our app evolves with industry trends to deliver a future-ready solution.",
    },
    {
      image: "/assets/home/careem-attract-3.webp",
      heading: "24/7 Support",
      description: "Our Careem Clone app is backed by round-the-clock assistance. From technical support to issue resolution, we ensure uninterrupted service for your business anytime, anywhere.",
    },
    {
      image: "/assets/home/careem-attract-4.webp",
      heading: "Advanced UX/UI",
      description: "Stand apart with a visually striking, modern, and user-friendly interface. Every screen is crafted for smooth navigation and engaging digital experiences.",
    },
    {
      image: "/assets/home/careem-attract-5.webp",
      heading: "White-Label App Solution",
      description: "Launch your brand with confidence using our white-label Careem Clone app. Customize it with your logo, colors, and identity to position your business at top.",
    },
    {
      image: "/assets/home/careem-attract-6.webp",
      heading: "Digital Payment Gateways",
      description: "Enable quick, secure, and flexible transactions with integrated digital payment gateways. Multiple options ensure a frictionless payment experience.",
    },
  ]
}

// const benifitData = {
//   label: "iWatch Advantages",
//   headingPart1: "",
//   headingPart2: "iWatch Features",
//   headingPart3: "in Careem Clone",
//   subHeading: "Multi-Service, Fast Experience with iWatch Support in Careem Clone App",
//   box: [
//     {
//       image: "/assets/home/careem-iwatch-1.webp",
//       mainImage: "/assets/home/careem-iwatch.webp",
//       title: "Sign- in page",
//       desc: "The page prompts users to register or sign in effortlessly using multiple options including iWatch. This smooth, secure, and convenient integration allows instant access to the app and a personalized range of services.",
//     },
//     {
//       image: "/assets/home/careem-iwatch-2.webp",
//       mainImage: "/assets/home/careem-iwatch2.webp",
//       title: "Log-In Screen Rides",
//       desc: "Users can log in within seconds and immediately view ride options nearby. With real-time tracking and an intuitive interface, they can check estimated fares, ride categories, and availability before confirming their trip.",
//     },
//     {
//       image: "/assets/home/careem-iwatch-3.webp",
//       mainImage: "/assets/home/careem-iwatch3.webp",
//       title: "Payment Selection",
//       desc: "The app offers multiple secure payment methods, including digital wallets, cards, net banking, and cash-on-delivery. Integrated payment gateways ensure fast, reliable, and transparent transactions for every ride or delivery.",
//     },
//     {
//       image: "/assets/home/careem-iwatch-4.webp",
//       mainImage: "/assets/home/careem-iwatch4.webp",
//       title: "Car Selection",
//       desc: "Customers can choose from a variety of vehicle options—from economy rides to premium cars—based on budget, comfort, and travel needs. Each option displays fare estimates, ratings, and driver details for informed decision-making.",
//     },
//     {
//       image: "/assets/home/careem-iwatch-5.webp",
//       mainImage: "/assets/home/careem-iwatch5.webp",
//       title: "Trip Request",
//       desc: "With just one tap, users can send a trip request to nearby drivers. The system instantly matches them with the most suitable driver, displaying details like ETA, contact information, and vehicle type for a smooth start to the journey.",
//     },
//   ],
// }

const forYouData = {
  newClass: "careem-for-you",
  text1: "Launch your multi service ",
  text2: "Business with us",
  des: "Take the first step toward building your multi-service empire with the Careem Clone app by Mobility Infotech. Streamline services, delight customers, and scale your business faster than ever before.",
  btn: "get a demo",
}

const powerData = {
  label: "Exclusive Addons",
  titlePart1: "Next-Gen",
  titlePart2: "Add-Ons",
  desc: "Setting new benchmarks in innovation with our advanced Careem Clone add-ons.",
  boxes: [
    {
      image: "/assets/home/careem-power-1.webp",
      heading: "Multiple Language",
      description: "Engage users in their native languages with built-in multilingual options for global accessibility.",
    },
    {
      image: "/assets/home/careem-power-2.webp",
      heading: "RTL Compatibility",
      description: "Cater to Arabic-speaking markets with Right-to-Left (RTL) text translation for ease and seamless usability.",
    },
    {
      image: "/assets/home/careem-power-3.webp",
      heading: "Multiple Currencies",
      description: "Offer smooth, flexible transactions by supporting various currencies across the globe.",
    },
    {
      image: "/assets/home/careem-power-4.webp",
      heading: "Gofer Delivery Booking",
      description: "Let delivery professionals book services online easily, ensuring faster and more reliable deliveries.",
    },
    {
      image: "/assets/home/careem-power-5.webp",
      heading: "GoferHandy Web Booking",
      description: "Enable users to book handyman services online with customizable features and convenience.",
    },
    {
      image: "/assets/home/careem-power-6.webp",
      heading: "Web Booking Gofer",
      description: "Allow customers to schedule and book taxi rides directly via website, without relying on a mobile app.",
    },
    {
      image: "/assets/home/careem-power-7.webp",
      heading: "Web Booking Gofer Tow",
      description: "A dedicated web add-on that connects users with tow truck services online, anytime they need roadside help.",
    },
    {
      image: "/assets/home/careem-power-8.webp",
      heading: "ChatGPT Integration",
      description: "Deliver instant AI-powered support. ChatGPT boosts customer engagement and improves efficiency.",
    },
    {
      image: "/assets/home/careem-power-9.webp",
      heading: "Algolia Search",
      description: "Empower users with faster and smarter search results, ensuring quick discovery of restaurants, dishes, or services.",
    },
    {
      image: "/assets/home/careem-power-10.webp",

      heading: "Crypto Wallet",
      description: "Stay future-ready with a secure crypto wallet that enables fast, secure and modern digital payments.",
    },
    {
      image: "/assets/home/careem-power-11.webp",
      heading: "Kiosk Ordering",
      description: "Simplify in-store operations by letting customers choose and place orders through kiosks—no staff needed.",
    },
    {
      image: "/assets/home/careem-power-12.webp",
      heading: "SUNMI Integration",
      description: "Streamline operations with receipt printing for kitchens, deliveries, and customer takeaways.",
    },
    {
      image: "/assets/home/careem-power-13.webp",
      heading: "Other Maps Support",
      description: "Integrate not just Google Maps but also Mapbox and TomTom to ensure accurate route planning worldwide.",
    },
    {
      image: "/assets/home/careem-power-14.webp",
      heading: "Local SMS Gateway",
      description: "Enhance security with localized SMS service for verification, delivering direct OTP codes to user phones.",

    },
    {
      image: "/assets/home/careem-power-15.webp",
      heading: "External DB Backup",
      description: "Protect your business with secure external database backup, minimizing risks of data or information loss.",
    },
    {
      image: "/assets/home/careem-power-16.webp",
      heading: "Provider Subscription",
      description: "Increase revenue by offering subscription packages that give providers better rankings, exposure, and visibility.",
    },
    {
      image: "/assets/home/careem-power-17.webp",
      heading: "Provider Wallet",
      description: "Allow delivery partners to maintain wallet balances for easy management of cash booking requests.",
    },
    {
      image: "/assets/home/careem-power-18.webp",
      heading: "Bidding – Handyman",
      description: "Introduce competitive bidding for handyman services, letting users choose the best price and provider.",
    },
    {
      image: "/assets/home/careem-power-19.webp",
      heading: "Bidding – Gofer Delivery",
      description: "Enable bidding for delivery services so customers can select cost-effective and timely solutions.",
    },
    {
      image: "/assets/home/careem-power-20.webp",
      heading: "Bidding – Gofer Taxi",
      description: "Enable users to enjoy driver bidding for competitive fares, enhanced flexibility, and an improved ride experience.",
    },
  ]
}

const advanceData = {
  titlePart1: "Boost Your",
  titlePart2: "Careem Clone App",
  titlePart3: "with Smart Add-ons",
  desc: "Supercharge your Careem Clone app with AI-powered smart add-ons that expand services, improve user experience, streamline operations, and drive sustainable growth across multiple on-demand industries.",
  boxes: [
    {
      image: "/assets/home/uber-eats-advance-1.webp",
      backImage: "/assets/home/uber-eats-advance-back1.webp",
      heading: "ChatBots",
      description: "Upgrade customer support with AI-driven chatbots that handle queries instantly. They provide intelligent suggestions based on user input, ensuring faster responses and improved customer satisfaction during live chat.",
    },
    {
      image: "/assets/home/uber-eats-advance-2.webp",
      backImage: "/assets/home/uber-eats-advance-back2.webp",
      heading: "Push Alerts",
      description: "Keep customers engaged with personalized AI-driven push notifications. From discounts to order updates, our AI-powered alerts ensure higher engagement, better retention, and ultimately faster revenue growth.",
    },
    {
      image: "/assets/home/uber-eats-advance-3.webp",
      backImage: "/assets/home/uber-eats-advance-back3.webp",
      heading: "Optimised Bookings",
      description: "Harness AI’s predictive capabilities to redefine the booking experience. By analyzing historical data and demand trends, the system forecasts peak service hours—helping you manage resources efficiently and boost profits.",
    },
  ]
}

const ApartData = {
  label: "Dynamic Functionalities of the Careem Clone App",
  titlePart1: "Key ",
  titlePart2: "Features That Set",
  titlePart3: "Our Careem Clone App Apart",
  boxes: [
    {
      image: "/assets/home/careem-apart-1.webp",
      heading: "Super Fast requests",
    },
    {
      image: "/assets/home/careem-apart-2.webp",
      heading: "Job history",
    },
    {
      image: "/assets/home/careem-apart-3.webp",
      heading: "Cancel Request",
    },
    {
      image: "/assets/home/careem-apart-4.webp",
      heading: "Accurate Location Fetching",
    },
    {
      image: "/assets/home/careem-apart-5.webp",
      heading: "Earnings Report",
    },
    {
      image: "/assets/home/careem-apart-6.webp",
      heading: "Exact Location Calculation",
    },
    {
      image: "/assets/home/careem-apart-7.webp",
      heading: "Fare Breakup",
    },
    {
      image: "/assets/home/careem-apart-8.webp",
      heading: "Multiple Service Category",
    },
    {
      image: "/assets/home/careem-apart-9.webp",
      heading: "Service Provider Availability",
    },
    {
      image: "/assets/home/careem-apart-10.webp",
      heading: "Easy To Customize",
    },
    {
      image: "/assets/home/careem-apart-11.webp",
      heading: "Round Clock Service",
    },
    {
      image: "/assets/home/careem-apart-12.webp",
      heading: "Multiple Car Category",
    },
    {
      image: "/assets/home/careem-apart-13.webp",
      heading: "Support",
    },
    {
      image: "/assets/home/careem-apart-14.webp",
      heading: "Gender Preference",
    },
    {
      image: "/assets/home/careem-apart-15.webp",
      heading: "Provider Online, Offline Status",
    },
    {
      image: "/assets/home/careem-apart-16.webp",
      heading: "Child Seat Accessibility",
    },
    {
      image: "/assets/home/careem-apart-17.webp",
      heading: "Handicap Seat Accessibility",
    },
    {
      image: "/assets/home/careem-apart-18.webp",
      heading: "Store Status",
    },
    {
      image: "/assets/home/careem-apart-19.webp",
      heading: "Item Management",
    },
    {
      image: "/assets/home/careem-apart-20.webp",
      heading: "Offers Management",
    },
    {
      image: "/assets/home/careem-apart-21.webp",
      heading: "Document Verification",
    },
    {
      image: "/assets/home/careem-apart-22.webp",
      heading: "SEO Friendly",
    },
    {
      image: "/assets/home/careem-apart-23.webp",
      heading: "Delivery Information",
    },
    {
      image: "/assets/home/careem-apart-24.webp",
      heading: "Km & Miles - Update",
    },
    {
      image: "/assets/home/careem-apart-25.webp",
      heading: "Store Tab View",
    },
    {
      image: "/assets/home/careem-apart-26.webp",
      heading: "Sunni Printer",
    },
    {
      image: "/assets/home/careem-apart-27.webp",
      heading: "Home Page New Design",
    },
    {
      image: "/assets/home/careem-apart-28.webp",
      heading: "Heat Map",
    },
    {
      image: "/assets/home/careem-apart-29.webp",
      heading: "Ride Sharing",
    },
    {
      image: "/assets/home/careem-apart-30.webp",
      heading: "Covid Features",
    },
    {
      image: "/assets/home/careem-apart-31.webp",
      heading: "Night/Peak Time Pricing",
    },
    {
      image: "/assets/home/careem-apart-32.webp",
      heading: "Service Biding",
    },
  ]
}

const demandData = {
  label: "Exclusive Addons",
  headingPart1: "Provide",
  headingPart2: "Diverse Services",
  headingPart3: "Through a Single On-Demand App",
  subHeading: "A comprehensive solution designed to simplify on-demand services effortlessly—all from one Careem Clone app by Mobility Infotech.",
  allTabs: [
    {
      name: "Deliveries",
      boxes: [
        {
          image: "/assets/home/careem-demand-delivery-1.webp",
          heading: "Food Delivery",
          description: "Order your favorite meals from local restaurants and enjoy fresh, hot, and on-time delivery at your doorstep.",
        },
        {
          image: "/assets/home/careem-demand-delivery-2.webp",
          heading: "Grocery Delivery",
          description: "Shop groceries from nearby stores and get them delivered instantly, making everyday shopping fast and hassle-free.",
        },
        {
          image: "/assets/home/careem-demand-delivery-3.webp",
          heading: "Pharmacy Delivery",
          description: "Order medicines and health essentials from trusted local pharmacies with quick and secure delivery.",
        },
        {
          image: "/assets/home/careem-demand-delivery-4.webp",
          heading: "Alcohol Delivery",
          description: "Get alcohol and beverages delivered from licensed local stores straight to your home—safe, fast, and convenient.",
        },
        {
          image: "/assets/home/careem-demand-delivery-5.webp",
          heading: "Marijuana Delivery",
          description: "Purchase cannabis products discreetly and safely from licensed dispensaries with reliable doorstep delivery.",
        },
        {
          image: "/assets/home/careem-demand-delivery-6.webp",
          heading: "Single Delivery",
          description: "Deliver anything to anyone in your city, from groceries and meals to parcels and packages—all in one app.",
        },
        {
          image: "/assets/home/careem-demand-delivery-7.webp",
          heading: "Multiply Delivery",
          description: "Send parcels to multiple recipients in a single trip, saving time, money, and operational resources.",
        },
        {
          image: "/assets/home/careem-demand-delivery-8.webp",
          heading: "Package Delivery",
          description: "Send and receive packages with efficient, smooth, and reliable delivery from nearby service providers.",
        },
      ]
    },
    {
      name: "ride",
      boxes: [
        {
          image: "/assets/home/careem-demand-ride-1.webp",
          heading: "Car Ride",
          description: "Book comfortable and affordable car rides with real-time tracking, secure payments, and trusted drivers.",
        },
        {
          image: "/assets/home/careem-demand-ride-2.webp",
          heading: "Auto Ride",
          description: "Choose quick, safe and budget-friendly auto rides for short-distance travel and everyday commuting.",
        },
        {
          image: "/assets/home/careem-demand-ride-3.webp",
          heading: "Moto Ride",
          description: "Opt for quick bike rides to skip the line, beat traffic, cut costs, and reach your destination faster than ever.",
        },
        {
          image: "/assets/home/careem-demand-ride-4.webp",
          heading: "Uber-Like Taxi",
          description: "Enjoy Uber-style taxi services with multiple vehicle options, secure booking, and transparent fares.",
        },
        {
          image: "/assets/home/careem-demand-ride-5.webp",
          heading: "Uber-Like Pool",
          description: "Save money and reduce carbon footprint by sharing rides with other passengers heading in the same direction.",
        },
      ]
    },
    {
      name: "on-demand",
      boxes: [
        {
          image: "/assets/home/careem-on-demand-ride-1.webp",
          heading: "Babysitting",
          description: "Book trusted babysitters to care for your children with safety, reliability, and flexibility.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-2.webp",
          heading: "Beauty Services",
          description: "Get professional beauty and grooming services at home, from hairstyling to spa treatments.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-3.webp",
          heading: "Car Wash",
          description: "Schedule on-demand car wash services at your doorstep for ultimate convenience.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-4.webp",
          heading: "Doctors",
          description: "Consult certified doctors on-demand, either through virtual appointments or at-home visits.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-5.webp",
          heading: "Electricians",
          description: "Hire skilled electricians for quick, reliable, and safe solutions to your electrical needs.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-6.webp",
          heading: "Pest Control",
          description: "Book expert pest control services to keep your home and office clean, safe, and hygienic.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-7.webp",
          heading: "Plumbers",
          description: "Get professional plumbing services for installations, repairs, and maintenance.",
        },
        {
          image: "/assets/home/careem-on-demand-ride-8.webp",
          heading: "Maids",
          description: "Hire housekeeping and cleaning services on-demand to keep your home spotless and organized.",
        },
      ]
    },
    {
      name: "grocery service",
      boxes: [
        {
          image: "/assets/home/careem-demand-delivery-2.webp",
          heading: "Grocery Delivery",
          description: "Order groceries from local stores and enjoy fast, hassle-free doorstep delivery whenever you need it.",
        },
      ]
    },
    {
      name: "laundry service",
      boxes: [
        {
          image: "/assets/home/careem-on-demand-ride-10.webp",
          heading: "Laundry",
          description: "Book laundry services from trusted providers—get your clothes cleaned, ironed, and delivered to your home.",
        },
      ]
    },
    {
      name: "uber for tow",
      boxes: [
        {
          image: "/assets/home/careem-demand-tow-2.webp",
          heading: "Towing Assistance",
          description: "Request towing services instantly during emergencies. With 24/7 availability and quick response times, get help anywhere, anytime.",
        },
      ]
    },
  ]
}

const featureData = {
  titlePart1: "Key Features of Our",
  titlePart2: "Careem Clone",
  titlePart3: "App",
  desc: "An all-in-one Careem Clone app built for seamless service management. From customer bookings to driver navigation and provider order handling, our feature-packed platform ensures smooth, reliable, and scalable operations for your business.",

  feature1: {
    image: "/assets/home/careem-feature-img1.webp",
    leftBoxes: [
      {
        title: "Service Selection",
        description: "Offer customers a single app to access multiple services—ride-hailing, food delivery, grocery shopping, pharmacy, courier, and more.",
        image: "/assets/home/careem-customer-1.webp",
      },
      {
        title: "Real-Time Tracking",
        description: "Enable users to track drivers, delivery agents, or service providers live on the map, ensuring transparency and trust.",
        image: "/assets/home/careem-customer-2.webp",
      },
      {
        title: "Service Customisation",
        description: "Give customers the freedom to customize food orders, ride preferences, and other service details to match their exact needs.",
        image: "/assets/home/careem-customer-3.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Order History",
        description: "Let users view past bookings and transactions for hassle-free reordering and reference.",
        image: "/assets/home/careem-customer-4.webp",
      },
      {
        title: "Scheduled Bookings",
        description: "Allow customers to pre-book services for a later date or time—perfect for rides, deliveries, and recurring needs.",
        image: "/assets/home/careem-customer-5.webp",
      },
      {
        title: "Notifications",
        description: "Keep users informed with real-time updates, order status alerts, and personalized push notifications for better engagement.",
        image: "/assets/home/careem-customer-6.webp",
      },
    ],
  },

  feature2: {
    image: "/assets/home/careem-feature-img2.webp",
    leftBoxes: [
      {
        title: "Accept/Reject Service",
        description: "Drivers can accept or decline service requests based on their availability and location, giving them full control over their work schedule.",
        image: "/assets/home/careem-driver-1.webp",
      },
      {
        title: "Service Status",
        description: "Drivers can update ride or delivery status (on the way, arrived, service completed) in real time, keeping customers fully informed.",
        image: "/assets/home/careem-driver-2.webp",
      },
      {
        title: "Heat Maps & Surge Pricing",
        description: "Drivers can view heat maps to identify high-demand zones and benefit from surge pricing opportunities, helping them maximize earnings.",
        image: "/assets/home/careem-driver-3.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Earnings",
        description: "Drivers can easily check detailed earnings reports, monitor payment history, and track pending payouts within the app.",
        image: "/assets/home/careem-driver-4.webp",
      },
      {
        title: "Manage Documents",
        description: "From licenses to permits, drivers can upload, update, and manage all necessary documents directly in the app for smooth verification.",
        image: "/assets/home/careem-driver-5.webp",
      },
      {
        title: "In-App Chat",
        description: "Built-in chat allows seamless communication between drivers and customers to resolve queries, confirm details, and ensure smooth service.",
        image: "/assets/home/careem-driver-6.webp",
      },
    ],
  },

  feature3: {
    image: "/assets/home/careem-feature-img3.webp",
    leftBoxes: [
      {
        title: "Store Status",
        description: "Store owners can toggle store availability (open/close) and update operational hours to match business schedules.",
        image: "/assets/home/careem-store-1.webp",
      },
      {
        title: "Menus/Products",
        description: "Restaurants and shops can showcase detailed menus and product catalogs with descriptions, pricing, and availability.",
        image: "/assets/home/careem-store-2.webp",
      },
      {
        title: "Set Order Amount",
        description: "Merchants can set a minimum order value to manage profitability and reduce small, low-margin orders.",
        image: "/assets/home/careem-store-3.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Manage Store",
        description: "Store owners can update delivery times, service coverage, packaging charges, and availability for smooth order management.",
        image: "/assets/home/careem-store-4.webp",
      },
      {
        title: "Discounts",
        description: "Offer percentage-based or flat discounts to boost sales, attract new customers, and encourage repeat orders.",
        image: "/assets/home/careem-store-5.webp",
      },
      {
        title: "Reviews & Ratings",
        description: "Access customer reviews and ratings to monitor service quality and identify areas for improvement.",
        image: "/assets/home/careem-store-6.webp",
      },
    ],
  },

  feature4: {
    image: "/assets/home/careem-feature-img4.webp",
    leftBoxes: [
      {
        title: "Availability Settings",
        description: "Providers can set and update their available working hours to receive service requests only when it suits them.",
        image: "/assets/home/careem-provider-1.webp",
      },
      {
        title: "Document Management",
        description: "Upload and manage licenses, certifications, and IDs securely to comply with platform requirements.",
        image: "/assets/home/careem-provider-2.webp",
      },
      {
        title: "Service Status Updates",
        description: "Providers can update each step of the service (accepted, in-progress, completed) so customers stay informed in real-time.",
        image: "/assets/home/careem-provider-3.webp",
      },
    ],

    rightBoxes: [
      {
        title: "Service Selection & Management",
        description: "Choose and manage offered services within the app, adjusting them as per skill set, specialization, and availability.",
        image: "/assets/home/careem-provider-4.webp",
      },
      {
        title: "Service Earnings",
        description: "Track detailed earnings, tips, and bonuses from completed services, with insights for income planning.",
        image: "/assets/home/careem-provider-5.webp",
      },
      {
        title: "Promotions & Offers",
        description: "Run promotional campaigns and offer discounts to build customer loyalty, increase bookings, and grow revenue.",
        image: "/assets/home/careem-provider-6.webp",
      },
    ],
  },
}

const processData = {
  titlePart1: "Our",
  titlePart2: "Careem Clone",
  titlePart3: "App Development Process.",
  desc: "All-in-One Careem Clone App for Seamless Service Management. From customer bookings to driver navigation and provider order handling, our feature-packed platform ensures smooth operations for your business.",
  boxes: [
    {
      title: "Requirement Gathering",
      image: "/assets/home/careem-process-1.webp",
      desc: "Our team analyzes your business objectives, audience, and service categories to design a Careem Clone app aligned with your vision and growth.",
    },
    {
      title: "Collect Third party Accounts",
      image: "/assets/home/careem-process-2.webp",
      desc: "We connect your app with secure payment gateways, map services, and communication APIs to enable smooth transactions, accurate navigation.",
    },
    {
      title: "Design & Development",
      image: "/assets/home/careem-process-3.webp",
      desc: "Our experts create a modern, intuitive UI/UX and develop a high-performing, scalable app that ensures seamless experience and interactions.",
    },
    {
      title: "Test and launch",
      image: "/assets/home/careem-process-4.webp",
      desc: "We test for quality, security, and performance, then launch seamlessly to deliver a smooth and reliable user experience.",
    },
  ]
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Careem Clone App by Mobility Infotech?",
    answer: "The Careem Clone App is an all-in-one multi-service platform that combines ride-hailing, food, grocery, pharmacy, and on-demand services in a single app, designed for seamless operations and business growth.",
  },
  {
    id: "1",
    question: "02. How does the Driver App work?",
    answer: "Drivers can accept or reject service requests, update ride/delivery status, track earnings, manage documents, and communicate with customers through an in-app chat feature. Heat maps and surge pricing help maximize earnings.",
  },
  {
    id: "2",
    question: "03. What services can customers access through the Careem Clone App?",
    answer: "Customers can book rides (car, auto, moto), food, grocery, pharmacy, alcohol, marijuana, package delivery, laundry, car wash, and other on-demand services like babysitting, beauty, and home services.",
  },
  {
    id: "3",
    question: "04. Can store owners manage their menus and products?",
    answer: "Yes! The Store App allows merchants to upload detailed menus or product catalogs, set minimum order amounts, manage store timings, delivery coverage, and apply discounts to attract customers.",
  },
  {
    id: "4",
    question: "05. How can providers manage their services?",
    answer: "Providers can set availability hours, choose service offerings, update service status in real-time, manage documents, track earnings, and offer promotions to attract more customers.",
  },
  {
    id: "5",
    question: "06. Does the app support multiple payments and currencies?",
    answer: "Yes, the app integrates digital payment gateways and supports multiple currencies, making transactions secure, fast, and convenient for customers worldwide.",
  },

  {
    id: "6",
    question: "07. What AI-powered features are included?",
    answer: "The app includes AI-driven chatbots, push notifications, optimized booking predictions, dynamic pricing, and smart search features to enhance user engagement and streamline operations.",
  },
];

export default function CareemClone() {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <BlaBlaHead data={HeadData} isCareem={true} />
      <CareemMulty />

      <Suspense fallback={null}>
        <CareemBoost data={boostData} />
        {isScroll && (
          <>
            <CareemFlow />
            <CareemAttract data={attractData} />
            {/* <CareemIwatch data={benifitData} /> */}
            <GroceryMarket data={forYouData} />
            <UberEatsPower data={powerData} />
            <UberEatsAdvance data={advanceData} />
            <CareemApart data={ApartData} />
            <CareemDemand data={demandData} />
            <CareemFeature data={featureData} />
            <CareemProcess data={processData} />
            <ShuttleAppreciation />
            <div className="zip-faq-fixer">
              <TaxiFaq faqData={faqData} />
            </div>
          </>
        )}
      </Suspense>
    </>
  )
}
